// frontend/src/utils/platformConfig.js

import { apiRequest } from "./api";
import { useState, useEffect } from "react";

let _companyConfig = {
  supportPhoneNumber: "+919999999999",
  supportEmail: "support@sramika.com"
};

const listeners = new Set();

export async function loadPlatformConfig() {
  try {
    const res = await apiRequest("/config/company", { method: "GET" });
    if (res?.data) {
      _companyConfig = res.data;
      listeners.forEach(listener => listener(_companyConfig));
    }
  } catch (err) {
    console.error("[platformConfig] Failed to load config:", err);
  }
}

export function getCompanyConfig() {
  return _companyConfig;
}

export function subscribeToConfig(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePlatformConfig() {
  const [config, setConfig] = useState(_companyConfig);
  
  useEffect(() => {
    // Catch up in case it loaded between mount and effect
    setConfig(_companyConfig);
    const unsubscribe = subscribeToConfig(setConfig);
    return () => unsubscribe();
  }, []);
  
  return config;
}
